
import { api_host, api_auth} from '../../common/globals/constants';

export const getLastStatusStepByNode = (user,objective, token, step) =>
    fetch(`${api_host}/reporte/online/indicadores/getLastStatusObjectiveByNodeStep/?user=${user}&token=${token}&objetivoId=${objective}&step=${step}`)
    .then(response => response.json())
    
